import * as React from 'react';
import { NewSpendingReportButtonProps, UserState } from '../interface/MyInterfaces';
import { openFilter } from '../actions/FilterPageActions';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';

class NewSpendingReportButton extends React.Component<NewSpendingReportButtonProps, {}> {
    constructor(props) {
        super(props);
        this.handleOpenFilterClick = this.handleOpenFilterClick.bind(this);
    }


    handleOpenFilterClick() {
        if (this.props.openFilter !== undefined)
            this.props.openFilter();
    }

    public render() {
        const returnimg = require('../images/return.png');

        return <a className="newreportlink" onClick={() => this.handleOpenFilterClick()}>
            <img src={String(returnimg)} width='15' height='15' /> New Report
         </a>

    }
}


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        { openFilter: openFilter }, dispatch
    )
}

export default connect(
    null,
    matchDispatchToProps
)(NewSpendingReportButton);